import React from 'react';
import logo from '../images/brand/lawns-out-west-logo.png';

const Navbar = () => {
  return (
    <nav className="navbar">
      <a href="#home" style={{position:'absolute',left:'-999px',top:'auto',width:'1px',height:'1px',overflow:'hidden'}}>
        Skip to content
      </a>
      <div className="container navbar-inner">
        <a href="#home" className="brand">
          <img src={logo} alt="Lawns Out West logo" className="brand-logo" />
          <span className="brand-name">Lawns Out West</span>
        </a>
        <div className="nav-links" style={{ gap: '1rem', flexWrap: 'wrap' }}>
          <a className="nav-link" href="#home">Home</a>
          <a className="nav-link" href="#services">Services</a>
          <a className="nav-link" href="#gallery">Gallery</a>
          <a className="nav-link" href="#testimonials">Testimonials</a>
          <a className="nav-link" href="#contact">Contact</a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;


